import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { tr, en, fr, es } from "@wedding/shared";

const LANG_KEY = "wedding-lang";

function detectLanguage(): string {
  const saved = localStorage.getItem(LANG_KEY);
  if (saved && ["tr", "en", "fr", "es"].includes(saved)) return saved;
  const nav = navigator.language.slice(0, 2);
  if (["tr", "en", "fr", "es"].includes(nav)) return nav;
  return "tr";
}

i18n.use(initReactI18next).init({
  resources: {
    tr: { translation: tr },
    en: { translation: en },
    fr: { translation: fr },
    es: { translation: es },
  },
  lng: detectLanguage(),
  fallbackLng: "tr",
  interpolation: { escapeValue: false },
});

// index.html `lang="tr"` ile gelir; algılanan dil farklıysa ilk yüklemede de
// düzelt — yoksa CSS `text-transform: uppercase` İngilizce metinde "İ" üretir
// (Türkçe büyük harf kuralı) ve ekran okuyucular yanlış dilde okur.
document.documentElement.lang = i18n.language;

i18n.on("languageChanged", (lng) => {
  localStorage.setItem(LANG_KEY, lng);
  document.documentElement.lang = lng;
});

export default i18n;
